// 修复后端时间格式在前端计算的兼容问题，主要可能是在safari上面
export const fixDateStr = (date: string) => date.replace(/-/gi, '/');

export const formatTimeStr = (num: number) => {
    const len = `00${num}`.length;

    return `00${num}`.slice(len - 2);
};

/**
 * 把数字字符串开头的 0 去掉。
 * @param input 输入的数字字符串
 */
function removeStarting0sFromString(input: string) {
    let firstNonZero = 0;

    while (input[firstNonZero] === '0') {
        firstNonZero += 1;
    }

    return input.slice(firstNonZero);
}

/**
 * 把 2018-07-20 13:55:24 转换成 7月20日 13:55
 * @param original
 */
export function transformToTimeWithChineseDate(original: string) {
    const month = removeStarting0sFromString(original.slice(5, 7));
    const day = removeStarting0sFromString(original.slice(8, 10));

    const rest = original.slice(11, -3);

    return `${month}月${day}日 ${rest}`;
}
